/* eslint-disable */
import React from "react";

import { Tr, Td, Tbody } from "./styles";

const TableBody = ({ tableData, columns }: any) => {
  return (
    <Tbody>
      {tableData.map((data: any, index: any) => {
        return (
          <Tr key={index} isOdd={index % 2 === 0 ? "#f0f0f0" : "#ffffff"}>
            {columns.map(({ accessor }: any) => {
              const tData = data[accessor] ? data[accessor] : "——";
              return <Td key={accessor}>{tData}</Td>;
            })}
          </Tr>
        );
      })}
    </Tbody>
  );
};

export default TableBody;
